import React from 'react';
import styled from 'styled-components';
import Dribble from 'images/social/dribble.svg';
import Facebook from 'images/social/facebook.svg';
import Instagram from 'images/social/instagram.svg';
import Linkedin from 'images/social/linkedin.svg';

const SocialMediaContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 4rem;

  ${({ theme }) => theme.breakpoints.maxTablet} {
    margin-bottom: 2.4rem;
    justify-content: space-between;
  }
`;

const SocialMediaLink = styled.a`
  &:hover {
    svg {
      path {
        fill: ${({ theme }) => theme.palette.navyGrayLighten5};
      }
    }
  }
`;

const SocialMedia = ({ className }) => (
  <SocialMediaContainer className={className}>
    <SocialMediaLink
      href="https://www.linkedin.com/company/markedway"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Linkedin />
    </SocialMediaLink>
    <SocialMediaLink
      href="https://www.facebook.com/markedway"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Facebook />
    </SocialMediaLink>
    <SocialMediaLink href="/" target="_blank" rel="noopener noreferrer">
      <Dribble />
    </SocialMediaLink>
    <SocialMediaLink
      href="https://www.instagram.com/marked.way"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Instagram />
    </SocialMediaLink>
  </SocialMediaContainer>
);

export default SocialMedia;
